import { render, staticRenderFns } from "./QuickLabelDetail.vue?vue&type=template&id=3b2e317c&scoped=true&"
import script from "./QuickLabelDetail.vue?vue&type=script&lang=js&"
export * from "./QuickLabelDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuickLabelDetail.vue?vue&type=style&index=0&id=3b2e317c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e317c",
  null
  
)

export default component.exports